@if (securityEquivalentsAlternativesData && !securityEquivalentsAlternativesData.multipleSecurity) {
  <div>
    <irb-com-es-security-equivalents [securityEquivalentsData]="securityEquivalentsAlternativesData"
    (securityEquivalentsChanged)="onSecurityEquivalentsChanged($event)"></irb-com-es-security-equivalents>
  </div>
}
@if (securityEquivalentsAlternativesData && securityEquivalentsAlternativesData.multipleSecurity) {
  <div>
    <mat-card class="block error">
      <mat-card-title style="white-space: pre-line;">
        <p>Equivalent Securities
          <p>
            <p style="font-weight: normal">
            This table is not available for display or editing when multiple securities are selected. </p>
          </mat-card-title>
        </mat-card>
      </div>
    }

    <div>
      @if (!isUiTest) {
        <irb-com-es-security-alternatives
          [securityAlternativesData]="securityEquivalentsAlternativesData"
          (securityEquivalentsAlternativeChanged)="onSecurityEquivalentsAlternativeChanged($event)"
        ></irb-com-es-security-alternatives>
      }
    </div>
